import type { RentalManagerAuthCheckUserInfoFeaturesDto } from '@zg-rentals/ts-rental-manager-api-client';
import type { Props as HeaderNavigationProps } from '../HeaderNavigation';

type Props = Partial<HeaderNavigationProps>;

const useNavDisplay = (props: Props) => {
  const { userModel: { features = {}, isEnterpriseCustomer = false, isSelfServeCustomer = false } = {} } = props;

  const {
    displayAccessMainContactSupport,
    displayAdManagement,
    displayAnalytics,
    displayBilling,
    displayMFHResources,
    displayMainAccountSettings,
    displayMainBilling,
    displayMainHelp,
    displayMainLeads,
    displayMainMaintenanceTracker,
    displayMainMessages,
    displayMainMyProperties,
    displayMainNotificationCenter,
    displayMainResources,
    displayMainSecuritySettings,
    displayOnboardingTasks,
    displayUserManagement,
  } = props;

  const {
    canAccessBilling,
    canAccessMainAccountSettings,
    canAccessMainAnalytics,
    canAccessMainBilling,
    canAccessMainContactSupport,
    canAccessMainContacts,
    canAccessMainHelp,
    canAccessMainMaintenanceTracker: aCanAccessMainMaintenanceTracker,
    canAccessMainMessages,
    canAccessMainMyProperties,
    canAccessMainNotificationCenter,
    canAccessMainPayments,
    canAccessMainResources,
    canAccessMainSecuritySettings,
    canAccessMultiFamilyResources,
    canAccessUserManagement,
  } = features as RentalManagerAuthCheckUserInfoFeaturesDto;

  const canAccessMainMaintenanceTracker = aCanAccessMainMaintenanceTracker && isEnterpriseCustomer === false;

  const displays = {
    displayAccessMainContactSupport: canAccessMainContactSupport || displayAccessMainContactSupport,
    displayAdManagement: isSelfServeCustomer || displayAdManagement,
    displayAnalytics: canAccessMainAnalytics || displayAnalytics,
    displayBilling: canAccessBilling || displayBilling,
    displayMFHResources: canAccessMultiFamilyResources || displayMFHResources,
    displayMainAccountSettings: canAccessMainAccountSettings || displayMainAccountSettings,
    displayMainBilling: canAccessMainBilling || displayMainBilling,
    displayMainHelp: canAccessMainHelp || displayMainHelp,
    displayMainLeads: canAccessMainContacts || displayMainLeads,
    displayMainMaintenanceTracker: canAccessMainMaintenanceTracker || displayMainMaintenanceTracker,
    displayMainMessages: canAccessMainMessages || displayMainMessages,
    displayMainMyProperties: canAccessMainMyProperties || displayMainMyProperties,
    displayMainNotificationCenter: canAccessMainNotificationCenter || displayMainNotificationCenter,
    displayMainPayments: canAccessMainPayments,
    displayMainResources: canAccessMainResources || displayMainResources,
    displayMainSecuritySettings: canAccessMainSecuritySettings || displayMainSecuritySettings,
    displayOnboardingTasks: isSelfServeCustomer || displayOnboardingTasks,
    displayUserManagement: canAccessUserManagement || displayUserManagement,
  };

  return {
    displays,
  };
};

export default useNavDisplay;
